import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { ToastContainer, toast } from "react-toastify";
import "sweetalert2/src/sweetalert2.scss";
import Lightbox from "react-image-lightbox";
import moment from "moment";
//import filter modal
import FilterModal from "components/Modal/FilterModal";
import {
    getRequest,
    postRequest,
    deleteRequest,
    putRequest,
    postRequestForm,
    deleteConfirmationWords,
} from "components/Common/Utils";

import paginationFactory, {
    PaginationProvider,
    PaginationListStandalone,
    SizePerPageDropdownStandalone,
} from "react-bootstrap-table2-paginator";
import axios from "axios";

import {
    Row,
    Col,
    Card,
    CardBody,
    CardTitle,
    Spinner,
    Badge,
    UncontrolledTooltip,
    Modal,
    Button,
} from "reactstrap";
import React, { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import ReactPaginate from "react-paginate";
import { change } from "redux-form";
import { id } from "date-fns/locale";

const filterObj = {
    first_name: "",
    last_name: "",
    gender: "",
    email: "",
    phone: "",
    country: "",
    nationality: "",
    bookingCode: "",
    bookingDate: "",
    agentEmail: "",
};

const WithdrawalRequest = (props) => {
    const [modal_center, setmodal_center] = useState(false);
    const [Categorydata, setCategorydata] = useState([]);
    const [loader, setLoader] = useState(false);
    const [searchText, setSearchText] = useState("");
    const [value, setValue] = React.useState(10);
    const [sort, setsort] = React.useState("");
    const [sortOrder, setsortOrder] = React.useState("desc");
    const [currentFPage, setCurrentFPage] = useState(1);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPage, setTotalPage] = useState(0);
    const [sizePerPageOrg, setSizePerPage] = useState(10);
    const [image, setImage] = React.useState("");
    const [openLightbox, setOpenLightBox] = React.useState(false);
    const [sizeList, setSizeList] = useState([]);
    const [model, setModel] = useState(false);
    const [canCreate, setCanCreate] = useState(true);
    const [canEdit, setCanEdit] = useState(true);
    const [canDelete, setCanDelete] = useState(true);
    const [canExport, setCanExport] = useState(true);
    const [filter, setFilter] = useState({ ...filterObj });
    const [loader2, setLoader2] = useState(false);
    const [CMshow, setCMshow] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [warning, setWarning] = useState("");
    const [requestData, setRequestData] = useState({});
    const [amount, setAmount] = useState(null);


    useEffect(() => {
        fetchTransactionsList();
    }, [currentPage]);

    useEffect(() => {
        fetchTransactionsList();
    }, [sort, sortOrder]);

    const GetValueOnChange = async (isActive, item) => {
        const payload = {
            id: item?._id,
            question: item?.question,
            answer: item?.answer,
            isPublished: isActive == true ? false : true,
            isDeleted: item?.isDeleted,
        }
        const res = await postRequest("support/quick-question/update", payload);
        if (res.status) {
            toast.success(res.message);
            fetchTransactionsList();
        } else {
            toast.error("Something went wrong");
            setLoader(false);
        }
    };
    const closeModal = () => {
        setModel(false);
    };

    const toggleModel = () => {
        console.log("toggleModel", model);
        setModel(!model);
    };


    const toggleApprovedAmount = (data) => {
        setCMshow(true);
        setRequestData(data);
    };


    const handleTableChange = (type, { page, sizePerPage, searchText }) => {
        if (type === "pagination") {
            if (page != currentPage) {
                setCurrentPage(page);
                console.log("page", page);
            }
        }

        console.log("type", type);

        if (type === "search") {
            console.log("searchText", searchText);
        }
    };

    const showLightBox = (image) => {
        setImage(image);
        setOpenLightBox(true);
    };

    function SNoFormatter(cellContent, row, i) {
        return <>{i + 1}</>;
    }

    const columns = [
        {
            text: "S.NO",
            formatter: SNoFormatter,
            sort: false,
        },
        {
            dataField: "txnId",
            text: "Transaction ID",
            sort: false,
        },
        {
            text: "Request Info",
            sort: false,
            formatter: (cell, row) => (
                <div
                    className="d-flex align-items-center justify-content-start text-start" style={{ gap: '10px' }}>
                    <span><img src={row?.requesterInfo?.image} width='40px' /></span>
                    <div style={{ color: '#696464' }}>
                        <span>{row?.requesterInfo?.first_name + ' ' + row?.requesterInfo?.last_name}, </span><br />
                        <span>{row?.requesterInfo?.email}</span> <br />
                        <span>Request By : {row?.requestBy}</span>
                    </div>
                </div>
            ),
        },

        {
            text: "Request Amount",
            sort: false,
            formatter: (cell, row) => (
                <>
                    <span>${row?.requestAmount.toLocaleString()}</span>
                </>
            ),
        },
        {
            text: "Approved Amount",
            sort: false,
            formatter: (cell, row) => (
                <>
                    {row?.status === "pending"
                        ? "--"
                        : row?.status === "confirmed" || row?.status === "settled"
                            ? <span style={{
                                color:
                                    row?.status === "pending"
                                        ? "orange"
                                        : row?.status === "confirmed" || row?.status === "settled"
                                            ? "green"
                                            : row?.status === "rejected" || row?.status === 'cancelled'
                                                ? "red"
                                                : "black",
                            }}>${row?.amount.toLocaleString()}</span>
                            : row?.status === "rejected" || row?.status === 'cancelled'
                                ? '--'
                                : '--'
                    }
                </>
            ),
        },

        {
            formatter: (cell, row) => (
                <span
                    style={{
                        color:
                            row?.status === "pending"
                                ? "orange"
                                : row?.status === "confirmed" || row?.status === "settled"
                                    ? "green"
                                    : row?.status === "rejected" || row?.status === 'cancelled'
                                        ? "red"
                                        : "black",
                    }}
                >
                    {row?.status.charAt(0).toUpperCase() + row?.status.slice(1)}
                </span>
            ),
            text: "Status",
            sort: false,
        },
        {
            text: "Request Date",
            sort: false,
            dataField: 'created',
            formatter: (cell, row) => (
                <>{moment(row?.createdAt).format("DD-MM-YYYY hh:mm A")} </>
            ),
        },

        // {
        //     dataField: "order",
        //     text: "Order Details",
        //     sort: false,
        // },

        {
            dataField: "actions",
            text: "Action",
            formatter: iconFormatter,
            sort: false,
        },
    ];
    const handleChange = (event) => {
        setSizePerPage(event.target.value);
        if (currentPage != 1) {
            setCurrentPage(1);
        } else {
            fetchTransactionsList(event.target.value);
        }
    };
    const handlesorting = (event) => {
        setsort(event.target.value);
    };
    const handlesortOrder = (event) => {
        setsortOrder(event.target.value);
    };

    const handleReload = () => {
        setSearchText("");
    };

    function iconFormatter(cellContent, row) {
        return (
            <>
                {row?.status === 'pending' ?
                    <div className="d-flex gap-2 justify-content-center">
                        <button
                            type="button"
                            className="btn d-flex gap-1 btn-primary"
                            onClick={() => toggleApprovedAmount(row)}
                        >
                            <i className="far fa-check-circle fs-5 text-light"></i>  Accept
                        </button>
                        <button
                            type="button"
                            className="btn d-flex gap-1 btn-danger"
                            onClick={() => handleRejectClick(row._id)}
                        >
                            <i className="far fa-times-circle fs-5 text-light"></i>   Reject
                        </button>
                    </div> : '--'}
            </>
        );
    }

    // const limit = 10;
    const fetchTransactionsList = async (limit = null) => {
        setLoader(true);
        const payload = {
            limit: limit ? limit : sizePerPageOrg,
            page: currentPage,
            search: searchText,
            sortOrder: sortOrder,
            filterArgs: [
                {
                    type: "regex",
                    status: sort
                }
            ]
        };
        try {
            const response = await postRequest(`withdrawal/list`, payload);
            const data = response.data;
            setTotalPage(data?.count);
            // setSizePerPage(sizePerPageOrg)
            setCurrentFPage(currentPage);
            setCategorydata(data?.list || []);
        } catch (error) {
            console.log("Failed to fetch data:", error);
        } finally {
            setLoader(false);
        }
    };

    const handleInputChange = (event) => {
        const inputValue = event.target.value;
        console.log(inputValue);
        setAmount(inputValue);
        if (!inputValue) {
            setWarning("Please enter a value.");
        } else if (parseFloat(inputValue) > requestData?.requestAmount) {
            setWarning(
                `The entered value cannot exceed ${requestData.requestAmount?.toLocaleString()}.`
            );
        } else {
            setWarning("");
        }
    };

    const handleSubmit = async (event) => {
        if (!amount) {
            setError("Amount is required.");
            return;
        }
        const statusMessage =
            parseFloat(amount) === requestData?.amount
                ? 'Withdrawal request approved successfully.'
                : 'Withdrawal request settled successfully.';
        try {
            setLoading(true);
            setError("");
            const response = await postRequest("withdrawal/admin-action", {
                id: requestData?._id,
                status: parseFloat(amount) == requestData?.amount ? 'confirmed' : 'settled',
                amount: parseFloat(amount),

            });
            if (response?.status) {
                setLoading(false);
                Swal.fire({
                    title: 'Success!',
                    allowOutsideClick: false,
                    text: statusMessage,
                    icon: 'success',
                    confirmButtonText: 'Okay'
                }).then((result) => {
                    if (result.isConfirmed) {
                        setCMshow(false);
                        fetchTransactionsList();
                        setAmount(null);
                    }
                });
            }
            else {
                Swal.fire({
                    title: 'Insufficient wallet!',
                    allowOutsideClick: false,
                    text: response?.message,
                    icon: 'error',
                    confirmButtonText: 'Close'
                })
            }
        }
        catch (error) {
            Swal.fire({
                title: 'Success!',
                allowOutsideClick: false,
                text: "Please try again later.",
                icon: 'error',
                confirmButtonText: 'Okay'
            })
        } finally {
            setLoading(false); // Stop the loading state
        }
    };

    // reject request
    const  handleRejectSubmit = async (_id) => {
        try {
            setLoading(true);
            setError("");
            const response = await postRequest("withdrawal/admin-action", {
                id: _id,
                status: 'cancelled',
            });
            if (response?.status) {
                setLoading(false);
                Swal.fire({
                    title: 'Rejected!',
                    text: 'The request has been rejected successfully.',
                    icon: 'success',
                    confirmButtonText: 'Okay',
                }).then(() => {
                    setCMshow(false);
                    fetchTransactionsList();
                });
            }
            else {
                Swal.fire({
                    title: 'Insufficient wallet!',
                    allowOutsideClick: false,
                    text: response?.message,
                    icon: 'error',
                    confirmButtonText: 'Close'
                })
            }
        }
        catch (error) {
            Swal.fire({
                title: 'Success!',
                allowOutsideClick: false,
                text: "Please try again later.",
                icon: 'error',
                confirmButtonText: 'Okay'
            })
        } finally {
            setLoading(false); // Stop the loading state
        }
    }
  
    const handleRejectClick = (_id) => {
        Swal.fire({
            title: 'Are you sure?',
            text: 'Do you really want to reject this request?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, Reject it',
            cancelButtonText: 'Cancel',
            allowOutsideClick: false,
        }).then((result) => {
            if (result.isConfirmed) {
                handleRejectSubmit(_id)
            }
        });
    };
    


    return (
        <>
            <React.Fragment>
                <ToastContainer />
                <Row>
                    <div className="col-md-6">
                        <div className="page-title-box">
                            <h4>Transactions Overview</h4>
                            <ol className="breadcrumb m-0">
                                <li className="breadcrumb-item active">Transactions Overview</li>:{" "}
                                <li className="breadcrumb-item">Withdrawal Requests</li>
                            </ol>
                        </div>
                    </div>
                    <div className="col-md-6 text-end">

                        &nbsp;&nbsp;&nbsp;
                    </div>
                    <Col className="col-12">
                        <Card>
                            {loader ? (
                                <CardBody style={{ height: "100px" }}>
                                    <Spinner
                                        color="info"
                                        style={{
                                            height: "4rem",
                                            width: "4rem",
                                            position: "absolute",
                                            left: "50%",
                                        }}
                                    >
                                        Loading...
                                    </Spinner>
                                </CardBody>
                            ) : (
                                <CardBody className="table-shorting">
                                    {
                                        <PaginationProvider
                                            pagination={paginationFactory({
                                                page: currentFPage,
                                                sizePerPage: sizePerPageOrg,
                                                totalSize: totalPage,
                                                custom: true,
                                            })}
                                        >
                                            {({ paginationProps, paginationTableProps }) => (
                                                <>
                                                    <ToolkitProvider
                                                        keyField="_id"
                                                        data={Categorydata}
                                                        columns={columns}
                                                    >
                                                        {(props) => (
                                                            <Row>
                                                                <Col className="col-lg-12 d-flex mb-3">
                                                                    <label className="mb-0 text-label">
                                                                        Page Size
                                                                    </label>

                                                                    <select
                                                                        value={sizePerPageOrg}
                                                                        onChange={handleChange}
                                                                        className="form-select"
                                                                        style={{ width: "7%" }}
                                                                    >
                                                                        <option value="10">10</option>

                                                                        <option value="20">20</option>

                                                                        <option value="50">50</option>
                                                                    </select>

                                                                    <label className="mb-0 text-label ms-3">
                                                                        Sort Order:
                                                                    </label>
                                                                    <select
                                                                        value={sortOrder}
                                                                        onChange={handlesortOrder}
                                                                        className="form-select"
                                                                        style={{ width: "10%" }}
                                                                    >
                                                                        <option value="asc"> Ascending</option>
                                                                        <option value="desc">Descending</option>
                                                                    </select>

                                                                    <label className="mb-0 text-label ms-3">
                                                                        Sort By:
                                                                    </label>
                                                                    <select
                                                                        value={sort}
                                                                        onChange={handlesorting}
                                                                        className="form-select"
                                                                        style={{ width: "10%" }}
                                                                    >
                                                                        <option value=''>Select Type</option>
                                                                        <option value="confirmed">Confirmed</option>
                                                                        <option value="settled">Settled</option>
                                                                        <option value="pending">Pending</option>    
                                                                        <option value="cancelled">Cancelled</option>
                                                                    </select>

                                                                    <div className="filter-item" style={{ width: '86.5%' }}>
                                                                        <input
                                                                            type="search"
                                                                            placeholder="Search"
                                                                            value={searchText}
                                                                            class="form-control"
                                                                            onChange={(e) =>
                                                                                setSearchText(e.target.value)
                                                                            }
                                                                            style={{ width: "30%" }}
                                                                        />
                                                                        <button
                                                                            onClick={() => {
                                                                                fetchTransactionsList();
                                                                            }}
                                                                            type="button"
                                                                            className="btn btn-primary mx-2"
                                                                        >
                                                                            Search
                                                                        </button>

                                                                        <button
                                                                            type="button"
                                                                            onClick={handleReload}
                                                                            className="btn btn-danger mx-2"
                                                                        >
                                                                            Reset
                                                                        </button>
                                                                        {/* <button
                                      type="button"
                                      onClick={toggleModel}
                                      className="btn btn-info"
                                    >
                                      Filter
                                    </button> */}
                                                                    </div>
                                                                </Col>

                                                                <Col className="col-lg-12 text-end">
                                                                    <BootstrapTable
                                                                        onTableChange={handleTableChange}
                                                                        remote={true}
                                                                        classes="table-striped"
                                                                        {...props.baseProps}
                                                                        {...paginationTableProps}
                                                                    />
                                                                </Col>
                                                            </Row>
                                                        )}
                                                    </ToolkitProvider>

                                                    <Row>
                                                        <Col className="col-lg-12 text-end">
                                                            <div className="text-md-right">
                                                                <PaginationListStandalone
                                                                    {...paginationProps}
                                                                />
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </>
                                            )}
                                        </PaginationProvider>
                                    }
                                </CardBody>
                            )}
                        </Card>
                    </Col>
                </Row>
                {openLightbox && (
                    <>
                        <Lightbox
                            mainSrc={image}
                            onCloseRequest={() => setOpenLightBox(false)}
                            toolbarButtons={[
                                <button
                                    className="btn btn-primary"
                                    key="download"
                                    onClick={handleDownload}
                                >
                                    Download
                                </button>,
                            ]}
                        />
                    </>
                )}

                <Modal
                    isOpen={CMshow}
                    size="md"
                    className="withdrow"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered={true}
                >
                    <div className="modal-header">
                        <h5 className="modal-title mt-0" id="myLargeModalLabel">
                            Accept Withdrawal
                        </h5>
                        <button
                            onClick={() => setCMshow(false)}
                            type="button"
                            className="close"
                            data-dismiss="modal"
                            aria-label="Close"
                            style={{ height: '27px' }}
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body p-4">

                        <div className="product-item request-info">
                            <div className="image-product">
                                <img
                                    src={requestData?.requesterInfo?.image}
                                />
                            </div>
                            <div className="product-info" style={{ width: "80%" }}>

                                <h6>{requestData?.requesterInfo?.first_name + ' ' + requestData?.requesterInfo?.last_name}</h6>
                                <h6>{requestData?.requesterInfo?.email} </h6>
                                <h6>Request Amount : ${requestData?.requestAmount} </h6>
                                <h6>Request By : {requestData?.requestBy} </h6>
                                <div className="form-floating theme-form-floating">
                                    <input
                                        type="number"
                                        className="form-control"
                                        id="amount"
                                        placeholder="amount"
                                        name="amount"
                                        value={amount}
                                        onChange={handleInputChange}
                                        required
                                    />
                                    <label htmlFor="amount"> Enter Amount </label>
                                </div>
                                {warning && <p className="mb-0 mt-1" style={{ color: "red" }}>{warning}</p>}
                            </div>
                        </div>
                    </div>

                    <div className="modal-footer">
                        <button type="button" className="btn btn-danger" onClick={() => {
                            setAmount(null),
                                setWarning(null),
                                setCMshow(false)
                        }}>
                            Cancel
                        </button>
                        <button disabled={warning} type="button" className="btn btn-primary" onClick={() => handleSubmit()}>
                            Submit
                        </button>
                    </div>

                </Modal>

            </React.Fragment>

        </>
    );
};

export default WithdrawalRequest;
